import React from 'react';

import './App.css';
import { AppContent } from './components/AppContent';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import { DeviceProvider } from './context/DeviceContext';
import { GeofenceAreaProvider } from './context/GeofenceAreaContext';
import { LogProvider } from './context/LogContext';
import { MapProvider } from './context/MapContext';
import { UserProvider } from './context/UserContext';

/**
 * Main App Component - Application root
 *
 * The top-level component that wraps the entire LifeFinder application.
 * Provides authentication, device, and map context to all child components
 * and renders the main application content.
 *
 * Architecture:
 * - AuthProvider: Manages authentication state across the app
 * - DeviceProvider: Manages device data and filtering (nested inside AuthProvider)
 * - MapProvider: Manages map state and interactions (nested inside DeviceProvider)
 * - AppContent: Handles view routing and main application logic
 */
const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <DeviceProvider>
          <GeofenceAreaProvider>
            <MapProvider>
              <LogProvider>
                <UserProvider>
                  <AppContent />
                </UserProvider>
              </LogProvider>
            </MapProvider>
          </GeofenceAreaProvider>
        </DeviceProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
